export default __webpack_public_path__ + "static/media/Background 5_00006.f70104b6.png";